<template>
  <div
    v-show="isMobile && isVisible && isActive" ref="mobileAppPromotion"
    class="mobile-app-promotion tw-px-16 tw-py-12">
    <div class="mobile-app-promotion__content">
      <div class="mobile-app-promotion__content__title">
        <span>Baixe o app e estude quando e onde quiser.</span>
      </div>
      <div class="mobile-app-promotion__content__buttons">
        <a :href="googlePlayUrl" target="_blank">
          Google Play
        </a>
        <a :href="appStoreUrl" target="_blank">
          App Store
        </a>
      </div>
    </div>
    <div class="mobile-app-promotion__close">
      <IconGoogle name="close" color="var(--white)" @click="closePromotion" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import emitter from "@/events/event-bus.ts";
import { useStateStore } from "@/store/state.store";
import { useLayoutStore } from "@/store/layout.store";

const stateStore = useStateStore();
const layoutStore = useLayoutStore();

const isMobile = ref(isMobileSize());
const isVisible = ref(false);
const isActive = ref(false);
const googlePlayUrl = ref<string | null>(null);
const appStoreUrl = ref<string | null>(null);

const getPromotionData = computed(() => layoutStore.getPromotionData);
const maxHeight = 72;

const isStudent = computed(() => stateStore.role === "student");

function getLayout(): HTMLElement | null {
  return document.querySelector(".layout-page__overflow");
}

function handleScroll() {
  const layout = getLayout();
  if (layout) {
    isVisible.value = layout.scrollTop < maxHeight;
  }
}

function handleResize() {
  isMobile.value = isMobileSize();
}

function isMobileSize(): boolean {
  return window.innerWidth < 768;
}

function closePromotion() {
  isActive.value = false;
  const layout = getLayout();
  layout?.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", handleResize);
}

onMounted(() => {
  if (isMobile.value && isStudent.value) {
    emitter.$on("promotionStatusFetched", () => {
      isActive.value = getPromotionData.value.mobileActive;
      googlePlayUrl.value = getPromotionData.value.googlePlayLink;
      appStoreUrl.value = getPromotionData.value.appStoreLink;
    });

    const layout = getLayout();
    if (layout) {
      isVisible.value = layout.scrollTop < maxHeight;
      layout.addEventListener("scroll", handleScroll);
    }
    window.addEventListener("resize", handleResize);
  }
});

onBeforeUnmount(() => {
  closePromotion();
});
</script>

<style lang="scss" scoped>
.mobile-app-promotion {
  background-color: var(--feedback-information-600);
  padding: 10px;
  width: 100%;
  height: max-content;
  max-height: 72px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__content__title {
    color: var(--white);
    font-size: 14px;
    font-weight: 400;
    width: 100%;
  }

  &__content__buttons {
    display: flex;
    gap: 16px;
  }

  &__content__buttons a {
    text-decoration: none;
    color: var(--white);
    text-decoration: underline;
  }

  &__close {
    cursor: pointer;

    * {
      width: 24px;
      height: 24px;
      color: var(--white);
    }
  }
}
</style>
